import { EncryptStorage } from 'encrypt-storage';
import Framework7         from 'framework7/framework7-lite.esm.bundle.js';

export const encryptStorage = new EncryptStorage(process.env.VUE_APP_PRSTK, {
  storageType: Framework7.device.desktop ? 'sessionStorage' : 'localStorage'
});